<template>
    <div class="col-12 mt-2">
        <Field v-model="formData.params.to" :errorMessage="errorMessages.to" :label="i18n('Recipients')"
            :disabled="submitted" :type="readonly ? 'readonly' : 'text'" />
    </div>  
    <div class="col-12 mt-2">
        <Field v-model="formData.params.cc" :errorMessage="errorMessages.body" :label="i18n('CC')"
            :disabled="submitted" :type="readonly ? 'readonly' : 'text'" />
    </div>
    <div class="col-12 mt-2">
        <Field v-model="formData.params.bcc" :errorMessage="errorMessages.body" :label="i18n('BCC')"
            :disabled="submitted" :type="readonly ? 'readonly' : 'text'" />
    </div>
    <div class="col-12 mt-2">
        <Field v-model="formData.params.subject" :errorMessage="errorMessages.subject" :label="i18n('Subject')"
            :disabled="submitted" :type="readonly ? 'readonly' : 'text'" />
    </div>
    <div class="col-12 mt-2">
        <Field v-model="formData.params.body" :errorMessage="errorMessages.body" :label="i18n('Email content')"
            :disabled="submitted" :type="readonly ? 'readonly' : 'textarea'" />
    </div>

    <div class="col-12 mt-2">
        <a class="btn btn-link" @click="showVars = !showVars">
            {{ showVars ? i18n('Hide variables') : i18n('Show variables') }}
        </a>
        <div v-if="showVars == true">
            <div class="toogle" v-for="triggerTypeParam in triggerType.triggerTypeParams" :key="triggerTypeParam">
                <div class="text-muted col-4">
                    {{ "{" + triggerTypeParam.param_name + "}" }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Field from "@/components/common/form/Field.vue";

export default {
    components: {
        Field,
    },
    data() {
        return {
            showVars: false,
        };
    },
    props: {
        submitted: {
            type: Boolean,
            required: true
        },
        readonly: {
            type: Boolean,
            required: true
        },
        formData: {
            type: Object,
            required: true
        },
        errorMessages: {
            type: Object,
            required: true
        },
        triggerType: {
            type: Object,
            required: true
        },
    },
    methods: {}
};
</script>